import { render, staticRenderFns } from "./GenericList.vue?vue&type=template&id=d156c43a&scoped=true"
import script from "./GenericList.vue?vue&type=script&lang=js"
export * from "./GenericList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d156c43a",
  null
  
)

export default component.exports